import React from "react";

import {FooterMenu} from "./footer/FooterMenu";
import {FooterLineMenu} from "./footer/FooterLineMenu";
import {FooterBotMenu} from "./footer/FooterBotMenu";
import {useMenuItems} from "./_hooks/useMenuItems";
import {Socials} from "./footer/Socials";
import {Whitepaper} from "./footer/Whitepaper";

import {useACFOptions} from "./_hooks/useACFOptions";

export const Footer = () => {

  const scfOpts = useACFOptions();
  const footerOpts = scfOpts?.footer || {};

  const menu1 = useMenuItems("FOOTER1_NAV");
  const menu2 = useMenuItems("FOOTER2_NAV");
  const menu3 = useMenuItems("FOOTER3_NAV");
  const menu4 = useMenuItems("FOOTER4_NAV");
  const menu5 = useMenuItems("FOOTER5_NAV");
  const menuBot = useMenuItems("FOOTER_BOT_NAV");

  return (
    <footer className="py-6">
      <div className="container">
        <div className="row">
          <div className="col-xl-6 col-lg-4 col-md-6 mb-8 mb-lg-0">
            {footerOpts?.title && (
                <p className="h3 text-black d-flex flex-column align-items-start">
                  {footerOpts.title.split(/\r?\n/).map( (word, index) =>
                    <span key={index} className={`mb-2 p-2 letter-spacing-6 ${index % 2 === 0 ? 'bg-pink' : 'bg-orange'}`}>{word}</span>
                  )}
                </p>
              )
            }
          </div>
          <div className="col-xl-6 col-lg-8 col-md-12">
            <div className="row">
              <div className="col-6 col-md-3 col-lg-3">
                <FooterMenu menu={menu1} />
              </div>
              <div className="col-6 col-md-3 col-lg-3">
                <FooterMenu menu={menu2} />
              </div>
              <div className="col-6 col-md-3 col-lg-3">
                <FooterMenu menu={menu3} />
              </div>
              <div className="col-6 col-md-3 col-lg-3">
                <FooterMenu menu={menu4} />
              </div>
              <div className="col-12 footer-menu d-flex mb-6 mb-lg-7">
                <FooterLineMenu menu={menu5} />
              </div>
              <div className="col-12 mb-5 mb-md-6 mb-lg-0">
                <Whitepaper links={footerOpts?.whitepaper.links} title={footerOpts?.whitepaper.title} />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <Socials links={footerOpts?.socials}/>
          </div>
        </div>
        <div className="row mt-6">
          <div className="col-md-7 col-lg-6 order-2 order-lg-1 mt-md-0 mt-6 text-md-end text-lg-start">
            {footerOpts?.copyright && (
              <p className="mb-0 fs-7 opacity-50 zg-line-height-m" dangerouslySetInnerHTML={{__html:footerOpts.copyright}}></p>
            )}
          </div>
          <div className="col-md-5 col-lg-6 order-1 order-lg-2">
            <div className="d-flex flex-wrap footer-links">
              <FooterBotMenu menu={menuBot} />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
